import { NumberInput as MantineNumberInput, NumberInputProps, Text } from '@mantine/core';
import { t } from 'i18next';
import { useState } from 'react';

type Props = NumberInputProps & {
    unit?: string
}

export const NumberInput = ({ unit, label, value, required, classNames, children, ...props }: Props) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <MantineNumberInput
            classNames={unit ? { ...classNames, section: 'number-input-decoration' } : classNames}
            decimalSeparator=","
            error={required && value === undefined && !isFocused &&
                t('isRequired', { label: label?.toString() || t('input') })
            }
            label={label}
            rightSection={unit && <Text className="text-base">{unit}</Text>}
            value={value}
            onBlur={() => setIsFocused(false)}
            onFocus={() => setIsFocused(true)}
            {...props}
        >
            {children}
        </MantineNumberInput >
    );
};